export function useWeekFinder() {
  return (targetDate) => {
    let [currentDay, currentMonth, currentDate, currentYear] = targetDate
      .toDateString()
      .split(" ");

    let weekStartDate = dateRanger(
      differenceInReqdataAndToday(currentDay, "sun"),
      targetDate
    );

    let weekEndDate = dateRanger(
      differenceInReqdataAndToday(currentDay, "sat"),
      targetDate
    );

    return { weekStartDate, weekSelectedDate: targetDate, weekEndDate };
  };
}

const differenceInReqdataAndToday = (today, reqDay) => {
  today = today && today.toLowerCase();
  reqDay = reqDay && reqDay.toLowerCase();

  switch (today) {
    case "sun":
      if (reqDay === "sun") return 0;
      else if (reqDay === "mon") return 1;
      else if (reqDay === "tue") return 2;
      else if (reqDay === "wed") return 3;
      else if (reqDay === "thu") return 4;
      else if (reqDay === "fri") return 5;
      else if (reqDay === "sat") return 6;
    case "mon":
      if (reqDay === "sun") return -1;
      else if (reqDay === "mon") return 0;
      else if (reqDay === "tue") return 1;
      else if (reqDay === "wed") return 2;
      else if (reqDay === "thu") return 3;
      else if (reqDay === "fri") return 4;
      else if (reqDay === "sat") return 5;
    case "tue":
      if (reqDay === "sun") return -2;
      else if (reqDay === "mon") return -1;
      else if (reqDay === "tue") return 0;
      else if (reqDay === "wed") return 1;
      else if (reqDay === "thu") return 2;
      else if (reqDay === "fri") return 3;
      else if (reqDay === "sat") return 4;
    case "wed":
      if (reqDay === "sun") return -3;
      else if (reqDay === "mon") return -2;
      else if (reqDay === "tue") return -1;
      else if (reqDay === "wed") return 0;
      else if (reqDay === "thu") return 1;
      else if (reqDay === "fri") return 2;
      else if (reqDay === "sat") return 3;
    case "thu":
      if (reqDay === "sun") return -4;
      else if (reqDay === "mon") return -3;
      else if (reqDay === "tue") return -2;
      else if (reqDay === "wed") return -1;
      else if (reqDay === "thu") return 0;
      else if (reqDay === "fri") return 1;
      else if (reqDay === "sat") return 2;
    case "fri":
      if (reqDay === "sun") return -5;
      else if (reqDay === "mon") return -4;
      else if (reqDay === "tue") return -3;
      else if (reqDay === "wed") return -2;
      else if (reqDay === "thu") return -1;
      else if (reqDay === "fri") return 0;
      else if (reqDay === "sat") return 1;
    case "sat":
      if (reqDay === "sun") return -6;
      else if (reqDay === "mon") return -5;
      else if (reqDay === "tue") return -4;
      else if (reqDay === "wed") return -3;
      else if (reqDay === "thu") return -2;
      else if (reqDay === "fri") return -1;
      else if (reqDay === "sat") return 0;
  }
};

const dateRanger = (val = 0, whichDate) => {
  let date;

  if (whichDate) {
    date = new Date(whichDate);
    date.setDate(date.getDate() + val);
    return date;
  }
};
